import React, { useState } from 'react';
import { TextField, Button } from '@mui/material';
import CategorySelector from './CatSelAddNewSupa';
import {FormContainer} from './cssStyles';
import '../App.css';
import {supabase} from './appDB'

const Form = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [idea, setIdea] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [submitted, setSubmitted] = useState(false); // Tracks submission state

  const handleSave = async () => {
    if (!name || !email || !idea || !selectedCategory) {
      alert('Please fill in all fields.');
      return;
    }
    // eslint-disable-next-line
    const { data, error } = await supabase
      .from('sparkcatcher')
      .insert([{ 
        applicantname: name,
        emailaddress: email, 
        idea: idea, 
        category: selectedCategory }]);

    if (error) {
      console.error('Error saving data:', error);
      alert('Failed to save your idea. Please try again.');
    } else {
      setSubmitted(true); // Show thank you message
    }
  };

  if (submitted) {
    return (
      <FormContainer>
        <h2>Thank You!</h2>
        <p>Your submission has been received. We appreciate your input!</p>
      </FormContainer>
    );
  }

  return (
    <FormContainer>
      <h2>Spark Catcher</h2>
      <TextField
        fullWidth
        label="Name"
        variant="outlined"
        margin="normal"
        style={{ background: '#333', borderRadius: 4 }}
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <TextField
        fullWidth
        label="Email Address"
        variant="outlined"
        margin="normal"
        style={{ background: '#333', borderRadius: 4 }}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <CategorySelector 
        selectedCategory={selectedCategory}
        onCategoryChange={setSelectedCategory}/>
      <TextField
        fullWidth
        label="Idea"
        variant="outlined"
        margin="normal"
        multiline
        rows={4}
        style={{ background: '#333', borderRadius: 4 }}
        value={idea}
        onChange={(e) => setIdea(e.target.value)}
      />
      <Button
        fullWidth
        variant="contained"
        style={{ marginTop: '1rem', backgroundColor: '#00c6d1' }}
        onClick={handleSave}
      >
        Save
      </Button>
    </FormContainer>
  );
};

export default Form;